import { useEdgeFunction } from "./00_useEdgeFunction";
import { UnitAndBuildingResponse } from "../types";

// 05_unit-and-building - matches GraphQL UNIT_SEARCH_TEXT query
export const useUnitAndBuilding = (unit_id?: string, building_id?: string) => {
  const input = unit_id && building_id 
    ? { unit_id, building_id } 
    : undefined;
  
  const { data, loading, error, execute, reset } = useEdgeFunction<UnitAndBuildingResponse>(
    "unit-and-building",
    input
  );

  // Manual execution method
  const getUnitAndBuilding = (unit_id: string, building_id: string) =>
    execute({ unit_id, building_id });

  return { data, loading, error, getUnitAndBuilding, reset };
};
